var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28H21V0H14V28Z",
    fill: "#343B47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28H7V0H0V28Z",
    fill: "#343B47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseBtn);
export default __webpack_public_path__ + "static/media/pause_btn.363384059b88db67fc71633a27d636fc.svg";
export { ForwardRef as ReactComponent };